














































































































































import Vue, { PropType } from "vue";

import RestClient, { RestError } from "../../RestClient";
import PointerMenu from "./PointerMenu.vue";
import Loading from "./Loading.vue";
import ExpandableView from "../controls/ExpandableView.vue";

import FormPrice from "./FormPrice.vue";
import { getEventBookingTotalPrice } from "../../shared/EventBookingJson";

import PriceJson, { PriceBookingJson } from "../../shared/PriceJson";

import { UserPermissionRank } from "../../shared/UserPermissionRank";

export default Vue.extend({
  name: "FormPriceSelect",
  components: {
    PointerMenu,
    Loading,
    ExpandableView,
    FormPrice,
  },
  props: {
    restClient: RestClient,
    loginId: Number,
    loginPermission: Number,
    availablePrices: Array as PropType<PriceJson[]>,
    data: Object as PropType<PriceBookingJson>,
    participantCount: Number,
    isPublic: Boolean,
    editable: Boolean,
    requiredInputs: {
      type: Array,
      default() {
        return [];
      },
    },
    customId: {
      default: "0",
    },
    validation: Object,
    submitValidation: Boolean,
  },
  data() {
    return {
      UserPermissionRank: UserPermissionRank,
      details: null as PriceBookingJson | null,
      selectedPriceId: null as number | null,
      totalPrice: undefined as {} | undefined,
      showMessages: {
        totalPrice: true,
      },
      toValidate: {} as any,
      loadingGeneral: false as boolean,
    };
  },
  created() {
    this.init();
  },
  mounted() {
    this.setCachedData();
  },
  methods: {
    init() {
      this.details = this.data;
      this.selectedPriceId = this.details?.ID || null;

      this.showMessages.totalPrice = this.participantCount <= 0 ? true : false;
    },

    setCachedData() {},

    //START set cached data

    //END set cached data

    inputValidation(key: any, prop: any) {
      if (prop) {
        if (!(key in this.toValidate)) {
          this.toValidate[key] = {};
        }
        this.toValidate[key][prop] = true;
      } else {
        this.toValidate[key] = true;
      }

      this.$emit("validateInput", "selectedPrice", key);

      this.$forceUpdate();
    },

    removeValidationHint(key: any, prop: any) {
      if (key in this.toValidate) {
        if (prop) {
          delete this.toValidate[key][prop];
        } else {
          delete this.toValidate[key];
        }
      }

      this.$forceUpdate();
    },

    //START set input data (where data be cached)

    //END set input data (where data be cached)

    setSelectedPrice() {
      let selectedPrice = this.availablePrices.find((i: PriceJson) => i.ID == this.selectedPriceId);

      if (selectedPrice) this.details = this.getPriceBooking(selectedPrice);
    },

    getPriceBooking(price: PriceJson): PriceBookingJson {
      return {
        ID: price.ID,
        title: price.title,
        remarks: price.remarks,
        isOnRequestOnly: price.isOnRequestOnly,
        cancellationFeePerParticipant: price.cancellationFeePerParticipant,
        cancellationFee: price.cancellationFee,
        cancellationFeeIncludedVATRate: price.cancellationFeeIncludedVATRate,
        cancellationRemarks: price.cancellationRemarks,
        priceDeposit: price.priceDeposit,
        priceDepositAdditionalParticipant: price.priceDepositAdditionalParticipant,
        priceDepositParticipantCount: price.priceDepositParticipantCount,
        priceDepositIncludedVATRate: price.priceDepositIncludedVATRate,
        priceNonDeposit: price.priceNonDeposit,
        priceNonDepositAdditionalParticipant: price.priceNonDepositAdditionalParticipant,
        priceNonDepositParticipantCount: price.priceNonDepositParticipantCount,
        priceNonDepositIncludedVATRate: price.priceNonDepositIncludedVATRate,
      };
    },

    getTotalPrice() {
      if (this.details != null) {
        this.totalPrice = getEventBookingTotalPrice(this.details, [], this.participantCount);
        this.$forceUpdate();
      }
    },

    getFormatPrice(price: number) {
      return price
        .toString()
        .padStart(3, "0")
        .replace(/(\d{2,2})$/g, ",$1")
        .replace("NaN", "");
    },
  },

  watch: {
    data: function () {
      this.details = this.data;
    },

    details: {
      handler(val, oldVal) {
        this.$emit("change", this.details);
        this.getTotalPrice();
      },
      deep: true,
    },

    participantCount: function () {
      this.showMessages.totalPrice = this.participantCount <= 0 ? true : false;
      this.getTotalPrice();
    },

    /* submitValidation: function () {
      if (this.submitValidation) {
        if (this.details != null) {
          this.validation = validateSepaMandate(this.details);
        }
      }
    }, */
  },

  computed: {
    permissionAble: function () {
      if (this.loginPermission >= this.UserPermissionRank.management) {
        return true;
      } else {
        return false;
      }
    },

    /* totalPrice: function (): {} | undefined {
      if (this.details != null) {
        return getEventBookingTotalPrice(this.details, [], this.participantCount);
      }
    }, */
  },
});
